import { Injectable } from '@angular/core';
import { Store, guid } from '@datorama/akita';

export interface CoacheeProfileNotesState {
	readonly notesChunkSize: number;
	readonly notesOffset: number;
	readonly notesId: string[];
	readonly reloadNotesTrigger: number;
}

@Injectable()
export class CoacheeProfileNotesStore extends Store<CoacheeProfileNotesState> {
	constructor() {
		super(
			{
				notesChunkSize: 20,
				notesOffset: 0,
				notesId: [],
			},
			{ name: `ui-coachee-profile-notes-${guid()}` }
		);
	}
}
